module.exports = __webpack_public_path__ + "images/nirvana/nirvana-home-feature.jpg";